<ng-container [ngSwitch]="currentStep">
  <ng-container *ngSwitchCase="0">
    <app-installation-migration-customer-ids
      (nextStep)="currentStep = 1"
    ></app-installation-migration-customer-ids>
  </ng-container>
  <ng-container *ngSwitchCase="1">
    <app-installation-migration-customer-devices
      (previousStep)="currentStep = 0"
      (nextStep)="currentStep = 2"
    ></app-installation-migration-customer-devices>
  </ng-container>
  <ng-container *ngSwitchCase="2">
    <app-installation-migration-confirmation
      (previousStep)="currentStep = 1"
      (finishError)="currentStep = 3"
      (finishSuccess)="openMigrationSuccessModal()"
    ></app-installation-migration-confirmation>
  </ng-container>
  <ng-container *ngSwitchCase="3">
    <app-installation-migration-error (retry)="currentStep = 1"></app-installation-migration-error>
  </ng-container>
</ng-container>
